<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="94%" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button v-if="showSubmit" type="primary" size="small" :disabled="actionBusy" @click="submit">提交审批</el-button>
            <el-button v-if="showWfApprove" type="primary" size="small" :disabled="actionBusy" @click="wfApprove">审批通过</el-button>
            <el-button v-if="showWfReject" type="primary" size="small" :disabled="actionBusy" @click="wfReject">驳回</el-button>
            <el-button v-if="showApprove" type="primary" size="small" :disabled="actionBusy" @click="approveHandle">审核</el-button>
            <el-button v-if="showUnapprove" type="primary" size="small" :disabled="actionBusy" @click="unapproveHandle">弃审</el-button>
            <el-button v-if="showTrail" type="primary" size="small" @click="trailVisible = true">审批轨迹</el-button>
            <el-button v-if="isAuth('purchase:purchaseIncomingInspection:update')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('purchase:purchaseIncomingInspection:delete')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="deleteHandle">删除</el-button>
          </el-button-group>
          <div v-if="workflowActionHint" class="wf-hint">{{ workflowActionHint }}</div>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="100px" :disabled="formReadonly">
      <el-row>
        <el-col :span="6">
          <el-form-item label="检验单号" prop="inspectionCode">
            <el-input v-model="dataForm.inspectionCode" :readonly="codeReadonly || !!dataForm.inspectionId" :placeholder="codeReadonly && !dataForm.inspectionId ? '保存时自动生成' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="检验日期" prop="inspectionDate">
            <el-date-picker v-model="dataForm.inspectionDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item v-if="arrivalRequired" label="到货通知" prop="arrivalNoticeId">
            <el-select v-model="dataForm.arrivalNoticeId" filterable :clearable="false" placeholder="选择已审到货通知" style="width:100%" @change="onNoticeChange">
              <el-option
                v-for="item in noticeOptions"
                :key="item.noticeId"
                :label="item.noticeCode + ' / ' + item.purchaseOrderCode"
                :value="item.noticeId"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-else label="采购订单" prop="purchaseOrderId">
            <el-select v-model="dataForm.purchaseOrderId" filterable :clearable="false" placeholder="选择已确认订单" style="width:100%" @change="onOrderChange">
              <el-option
                v-for="item in orderOptions"
                :key="item.purchaseOrderId"
                :label="item.purchaseOrderCode + ' / ' + item.supplierName"
                :value="item.purchaseOrderId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="供应商">
            <span>{{ dataForm.supplierName || '—' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="采购单号">
            <span>{{ dataForm.purchaseOrderCode || '—' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="备注">
            <el-input v-model="dataForm.remark" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-table border :data="dataForm.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
        <el-table-column type="index" label="序号" width="55" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="110" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="120" header-align="center" align="left" />
        <el-table-column prop="specs" label="规格" min-width="90" header-align="center" align="left" />
        <el-table-column prop="inspectionSpecDoc" label="检验规范" min-width="140" header-align="center" align="left" show-overflow-tooltip />
        <el-table-column prop="remainQuantity" label="可送检" width="80" header-align="center" align="left">
          <template slot-scope="scope">{{ formatQty(scope.row.remainQuantity) }}</template>
        </el-table-column>
        <el-table-column prop="inspectQty" label="送检数量" width="180" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.inspectQty" :min="0" :max="formReadonly ? Math.max(Number(scope.row.inspectQty || 0), Number(scope.row.remainQuantity || 0)) : Number(scope.row.remainQuantity || 0)" :precision="2" style="width:100%" @change="onInspectChange(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="passQty" label="合格" width="180" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.passQty" :min="0" :max="Number(scope.row.inspectQty || 0)" :precision="2" style="width:100%" @change="onPassFailChange(scope.row, 'pass')" />
          </template>
        </el-table-column>
        <el-table-column prop="failQty" label="不合格" width="180" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.failQty" :min="0" :max="Number(scope.row.inspectQty || 0)" :precision="2" style="width:100%" @change="onPassFailChange(scope.row, 'fail')" />
          </template>
        </el-table-column>
        <el-table-column prop="disposition" label="处置" width="120" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-if="Number(scope.row.failQty) > 0" v-model="scope.row.disposition" placeholder="处置" style="width:100%">
              <el-option label="待定" value="pending" />
              <el-option label="退货" value="return" />
              <el-option label="索赔" value="claim" />
              <el-option label="让步接收" value="concession" />
            </el-select>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!formReadonly" label="操作" width="70" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeLine(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :disabled="submitLoading" @click="submitHandle">确定</el-button>
    </span>
    <workflow-trail-dialog :visible.sync="trailVisible" :workflow-instance="dataForm.workflowInstance" :tasks="trailTasks" />
  </el-dialog>
</template>

<script>
import WorkflowTrailDialog from '../../components/WorkflowTrailDialog.vue'
import request from '../../api/request'
import { docAction, docGet, docInfo, docSave } from '../../api/erp/doc'
import { fetchPerms } from '../../api/auth'
import { canShowDirectApproveButton, isWorkflowEditable, normalizeWorkflowDocUi, shouldShowWorkflowTrail } from '../../utils/workflow'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

function blankForm(id) {
  return {
    inspectionId: id || '',
    inspectionCode: '',
    inspectionDate: today(),
    purchaseOrderId: '',
    purchaseOrderCode: '',
    arrivalNoticeId: '',
    supplierId: '',
    supplierName: '',
    approveStatus: '0',
    workflowStatus: 'draft',
    workflowInstance: null,
    myPendingTask: null,
    workflowDocUi: null,
    remark: '',
    lines: []
  }
}

export default {
  name: 'PurchaseIncomingInspectionAddOrUpdate',
  components: { WorkflowTrailDialog },
  data() {
    return {
      visible: false,
      readonly: false,
      submitLoading: false,
      actionBusy: false,
      codeReadonly: false,
      workflowDocUiReady: false,
      trailVisible: false,
      arrivalRequired: false,
      noticeOptions: [],
      orderOptions: [],
      permCodes: [],
      dataForm: blankForm(),
      dataRule: {
        inspectionCode: [{ required: true, message: '检验单号不能为空', trigger: 'blur' }],
        inspectionDate: [{ required: true, message: '检验日期不能为空', trigger: 'change' }],
        arrivalNoticeId: [{ required: true, message: '请选择到货通知', trigger: 'change' }],
        purchaseOrderId: [{ required: true, message: '请选择采购订单', trigger: 'change' }]
      }
    }
  },
  computed: {
    formReadonly() {
      return this.readonly || this.dataForm.approveStatus === '2' || !this.canEditDoc
    },
    formRules() {
      const rules = { ...this.dataRule }
      if (this.codeReadonly) delete rules.inspectionCode
      if (this.arrivalRequired) delete rules.purchaseOrderId
      else delete rules.arrivalNoticeId
      return this.formReadonly ? {} : rules
    },
    dialogTitle() {
      if (this.readonly) return '查看来料检验'
      return this.dataForm.inspectionId ? '修改来料检验' : '新增来料检验'
    },
    showViewToolbar() {
      return this.readonly && !!this.dataForm.inspectionId
    },
    workflowUi() {
      return normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
    },
    canEditDoc() {
      return isWorkflowEditable(this.dataForm.workflowStatus, this.dataForm.approveStatus)
    },
    allowSaveDirectApprove() {
      const ui = this.workflowUi
      return !!(ui && ui.workflowEnabled && !ui.definitionMatched && ui.directApproveAllowed)
    },
    showApprove() {
      if (!this.showViewToolbar || !this.workflowDocUiReady) return false
      if (String(this.dataForm.approveStatus) === '2') return false
      if (!canShowDirectApproveButton(this.dataForm.workflowDocUi)) return false
      if (this.isAuth('purchase:purchaseIncomingInspection:approve')) return true
      return this.allowSaveDirectApprove && (this.isAuth('purchase:purchaseIncomingInspection:save') || this.isAuth('purchase:purchaseIncomingInspection:update'))
    },
    showUnapprove() {
      return this.showViewToolbar && this.isAuth('purchase:purchaseIncomingInspection:unapprove') && String(this.dataForm.approveStatus) === '2'
    },
    showSubmit() {
      const ui = this.workflowUi
      if (!this.showViewToolbar || !this.workflowDocUiReady || !ui || !ui.submitAllowed) return false
      const uid = (this.$store.state.user || {}).id
      if (this.dataForm.createBy && uid && String(this.dataForm.createBy) !== String(uid)) return false
      return this.isAuth('purchase:purchaseIncomingInspection:submit') || this.isAuth('purchase:purchaseIncomingInspection:save') || this.isAuth('purchase:purchaseIncomingInspection:update')
    },
    showWfApprove() {
      const task = this.dataForm.myPendingTask
      return this.showViewToolbar && this.isAuth('workflow:task:approve') && task && task.taskId
    },
    showWfReject() {
      return this.showWfApprove && this.isAuth('workflow:task:reject')
    },
    showTrail() {
      return shouldShowWorkflowTrail({
        inViewMode: this.showViewToolbar,
        workflowInstance: this.dataForm.workflowInstance,
        workflowDocUi: this.workflowUi,
        workflowDocUiReady: this.workflowDocUiReady
      })
    },
    trailTasks() {
      const inst = this.dataForm.workflowInstance
      return (inst && inst.tasks) || []
    },
    workflowActionHint() {
      const ui = this.workflowUi
      if (!ui || !ui.workflowEnabled || String(this.dataForm.approveStatus) === '2') return ''
      if (ui.inApproval) {
        const uid = (this.$store.state.user || {}).id
        const inst = this.dataForm.workflowInstance
        if (!(this.dataForm.myPendingTask && this.dataForm.myPendingTask.taskId) && inst && uid && String(inst.submitBy) === String(uid)) {
          return '当前步骤需由其他审批人处理（不允许提交人自审），请等待待办人审批。'
        }
        return ''
      }
      if (!ui.definitionMatched && ui.submitAllowed) return '已启用多级审批，尚未配置审批流程。请点击「提交审批」查看配置指引。'
      if (!ui.definitionMatched && ui.directApproveAllowed) return '已启用多级审批，尚未配置匹配的审批流程，可直接审核或联系管理员配置流程。'
      if (!ui.definitionMatched && !ui.directApproveAllowed && !ui.submitAllowed) return '已启用多级审批，请先在「审批流程定义」中配置来料检验流程后再提交。'
      return ''
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.readonly = !!readonly
      this.visible = true
      this.submitLoading = false
      this.actionBusy = false
      this.codeReadonly = !!id
      this.workflowDocUiReady = false
      this.dataForm = blankForm(id)
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.clearValidate()
      })
      if (!id) this.resolveCode()
      this.loadSwitches().then(() => {
        if (id) {
          docInfo('/purchase/purchaseIncomingInspection', id).then(res => {
            const body = res.data || {}
            this.dataForm = {
              ...blankForm(id),
              ...body,
              inspectionDate: (body.inspectionDate || '').slice(0, 10),
              lines: (body.lines || []).map(line => ({
                ...line,
                inspectQty: Number(line.inspectQty),
                passQty: Number(line.passQty),
                failQty: Number(line.failQty),
                remainQuantity: line.remainQuantity != null ? Number(line.remainQuantity) : Number(line.inspectQty)
              }))
            }
            this.workflowDocUiReady = !!normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
            this.loadSourceOptions(body.arrivalNoticeId, body.purchaseOrderId)
          }).catch(() => {})
        } else {
          this.loadSourceOptions()
        }
      })
    },
    loadSwitches() {
      return request.get('/purchase/purchaseIncomingInspection/switches').then(res => {
        const data = res.data || {}
        this.arrivalRequired = !!data.arrivalRequired
      }).catch(() => {
        this.arrivalRequired = false
      })
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'purchaseIncomingInspection' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.inspectionCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('inspectionCode')
        })
      }).catch(() => {})
    },
    loadSourceOptions(includeNoticeId, includePurchaseOrderId) {
      if (this.arrivalRequired) {
        docGet('/purchase/purchaseIncomingInspection/noticesForInspection', {
          excludeInspectionId: this.dataForm.inspectionId || '',
          includeNoticeId: includeNoticeId || ''
        }).then(res => { this.noticeOptions = res.data || [] }).catch(() => {})
      } else {
        docGet('/purchase/purchaseIncomingInspection/ordersForInspection', {
          excludeInspectionId: this.dataForm.inspectionId || '',
          includePurchaseOrderId: includePurchaseOrderId || ''
        }).then(res => { this.orderOptions = res.data || [] }).catch(() => {})
      }
    },
    onNoticeChange(noticeId) {
      this.dataForm.lines = []
      const hit = this.noticeOptions.find(item => item.noticeId === noticeId)
      if (!noticeId || !hit) {
        this.dataForm.purchaseOrderId = ''
        this.dataForm.purchaseOrderCode = ''
        this.dataForm.supplierId = ''
        this.dataForm.supplierName = ''
        return
      }
      this.dataForm.purchaseOrderId = hit.purchaseOrderId
      this.dataForm.purchaseOrderCode = hit.purchaseOrderCode
      this.dataForm.supplierId = hit.supplierId
      this.dataForm.supplierName = hit.supplierName
      if (!this.formReadonly) this.applyLines()
    },
    onOrderChange(purchaseOrderId) {
      this.dataForm.lines = []
      const hit = this.orderOptions.find(item => item.purchaseOrderId === purchaseOrderId)
      if (!purchaseOrderId || !hit) {
        this.dataForm.purchaseOrderCode = ''
        this.dataForm.supplierId = ''
        this.dataForm.supplierName = ''
        return
      }
      this.dataForm.purchaseOrderCode = hit.purchaseOrderCode
      this.dataForm.supplierId = hit.supplierId
      this.dataForm.supplierName = hit.supplierName
      if (!this.formReadonly) this.applyLines()
    },
    applyLines() {
      const params = { excludeInspectionId: this.dataForm.inspectionId || '' }
      if (this.arrivalRequired) {
        if (!this.dataForm.arrivalNoticeId) return
        params.arrivalNoticeId = this.dataForm.arrivalNoticeId
      } else {
        if (!this.dataForm.purchaseOrderId) return
        params.purchaseOrderId = this.dataForm.purchaseOrderId
      }
      docGet('/purchase/purchaseIncomingInspection/linesForInspection', params).then(res => {
        const lines = res.data || []
        if (!lines.length) {
          this.$message.warning('没有可送检明细（需物料启用来料检验）')
          return
        }
        this.dataForm.lines = lines.map(line => ({
          ...line,
          remainQuantity: Number(line.remainQuantity || 0),
          inspectQty: Number(line.inspectQty != null ? line.inspectQty : line.remainQuantity || 0),
          passQty: Number(line.passQty != null ? line.passQty : line.remainQuantity || 0),
          failQty: Number(line.failQty || 0),
          disposition: line.disposition || 'pending'
        }))
      }).catch(() => {})
    },
    onInspectChange(row) {
      const inspect = Number(row.inspectQty || 0)
      const fail = Number(row.failQty || 0)
      row.passQty = Math.max(0, Number((inspect - fail).toFixed(2)))
      if (fail <= 0) row.disposition = 'pending'
    },
    onPassFailChange(row, which) {
      const inspect = Number(row.inspectQty || 0)
      if (which === 'pass') {
        row.failQty = Math.max(0, Number((inspect - Number(row.passQty || 0)).toFixed(2)))
      } else {
        row.passQty = Math.max(0, Number((inspect - Number(row.failQty || 0)).toFixed(2)))
      }
      if (Number(row.failQty || 0) <= 0) row.disposition = 'pending'
    },
    removeLine(index) {
      this.dataForm.lines.splice(index, 1)
    },
    formatQty(val) {
      if (val == null || val === '') return '-'
      const n = Number(val)
      if (Number.isNaN(n)) return '-'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    validateLines() {
      if (!this.dataForm.lines.length) return '请至少维护一条检验明细'
      for (let i = 0; i < this.dataForm.lines.length; i++) {
        const line = this.dataForm.lines[i]
        const n = i + 1
        if (!(Number(line.inspectQty) > 0)) return `第${n}行：送检数量必须大于0`
        if (Number((Number(line.passQty || 0) + Number(line.failQty || 0)).toFixed(2)) !== Number(Number(line.inspectQty || 0).toFixed(2))) {
          return `第${n}行：合格数量与不合格数量之和必须等于送检数量`
        }
        if (Number(line.passQty || 0) === 0 && Number(line.failQty || 0) === 0) {
          return `第${n}行：合格数量和不合格数量不能同时为0`
        }
        if (Number(line.failQty || 0) > 0 && !line.disposition) {
          return `第${n}行：不合格时请选择处置方式`
        }
      }
      return ''
    },
    submitHandle() {
      const lineErr = this.validateLines()
      if (lineErr) {
        this.$message.error(lineErr)
        return
      }
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = {
          ...this.dataForm,
          arrivalNoticeId: this.arrivalRequired ? this.dataForm.arrivalNoticeId : null,
          lines: this.dataForm.lines.map(line => ({
            purchaseOrderLineId: line.purchaseOrderLineId,
            arrivalNoticeLineId: line.arrivalNoticeLineId || null,
            materialId: line.materialId,
            inspectQty: line.inspectQty,
            passQty: line.passQty,
            failQty: line.failQty,
            disposition: Number(line.failQty) > 0 ? (line.disposition || 'pending') : 'pending',
            inspectionSpec: line.inspectionSpec || '',
            remark: line.remark || ''
          }))
        }
        docSave('/purchase/purchaseIncomingInspection', payload, 'inspectionId').then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    },
    editFromView() { this.readonly = false },
    reloadDoc() {
      if (!this.dataForm.inspectionId) return
      this.init(this.dataForm.inspectionId, true)
    },
    approveHandle() {
      this.$confirm('审核后可下推采购入库，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/purchase/purchaseIncomingInspection', 'approve', { inspectionId: this.dataForm.inspectionId }).then(() => {
          this.$message.success('审核成功')
          this.$emit('refreshDataList')
          this.reloadDoc()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    unapproveHandle() {
      this.$confirm('弃审前请确保无关联采购入库单，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/purchase/purchaseIncomingInspection', 'unapprove', { inspectionId: this.dataForm.inspectionId }).then(() => {
          this.$message.success('弃审成功')
          this.$emit('refreshDataList')
          this.reloadDoc()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    deleteHandle() {
      this.$confirm('确定删除该来料检验单?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/purchase/purchaseIncomingInspection', 'delete', { inspectionId: this.dataForm.inspectionId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    submit() {
      const ui = this.workflowUi
      if (ui && ui.workflowEnabled && !ui.definitionMatched) {
        this.$alert('尚未配置来料检验审批流程，请先在「审批流程定义」中新增并启用流程（至少一个审批步骤）后再提交。', '未配置审批流程', { type: 'warning', confirmButtonText: '我知道了' })
        return
      }
      this.$confirm('提交后将进入审批流程，期间不可修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        request.post('/workflow/submit', { bizType: 'purchaseIncomingInspection', bizId: this.dataForm.inspectionId }).then(() => {
          this.$message.success('提交成功')
          this.reloadDoc()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfApprove() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('审批意见（可选）', '审批通过', { inputType: 'textarea', confirmButtonText: '通过' }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/approve', { taskId: task.taskId, comment: value || '' }).then(() => {
          this.$message.success('审批通过')
          this.$emit('refreshDataList')
          this.reloadDoc()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfReject() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('请输入驳回原因', '审批驳回', {
        inputType: 'textarea',
        confirmButtonText: '驳回',
        inputValidator: v => !!(v && String(v).trim()) || '驳回原因不能为空'
      }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/reject', { taskId: task.taskId, comment: String(value).trim() }).then(() => {
          this.$message.success('已驳回')
          this.$emit('refreshDataList')
          this.reloadDoc()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; line-height: 32px; }
.doc-dialog-actions { display: flex; flex-direction: column; align-items: flex-end; }
.doc-dialog-actions >>> .el-button-group { display: flex; flex-wrap: wrap; }
.wf-hint { margin-top: 6px; color: #e6a23c; font-size: 12px; line-height: 1.4; }
</style>
